import React, {useEffect, useState} from "react";
import {Button, Form, Input, Select, message, Card, Breadcrumb} from "antd";
import {SaveOutlined, CloseOutlined} from "@ant-design/icons";
import {Link, useNavigate, useParams} from "react-router-dom";
import SearchCompany from "../../../components/SearchCompany";
import SearchDevice from "../../../components/SearchDevice";
import DeleteVehicle from "./DeleteVehicle";
import {
    useGetVehicleByIdQuery,
    useGetVehicleQuery,
    useUpdateVehicleByIdMutation
} from "../../../slices/rootApiSlices/vehicleApiSlice";
import {useSelector} from "react-redux";

const UpdateVehicle = () => {

    const [form] = Form.useForm();
    const navigate = useNavigate();
    const {user} = useSelector(state => state.auth);
    const {refetch: refetchAllVehicles} = useGetVehicleQuery(user?.token);

    const {id} = useParams();

    const {refetch: refetchVehicleById, data, isLoading} = useGetVehicleByIdQuery({
        token: user?.token,
        id: id
    });

    const [updateHandle, updateLoading] = useUpdateVehicleByIdMutation();

    useEffect(() => {
        if (data) {
            form.setFieldsValue({
                chassisNumber: data?.chassisNumber,
                plateNumber: data?.plateNumber,
                operationNumber: data?.operationNumber,
                fuelType: data?.fuelType,
                isActive: data?.isActive,
                company_id: data?.company_id,
                device_id: data?.device_id,
                brand: data?.brand,
                year: data?.year
            });
        }
    }, [data, form]);


    const [chassisNumber, setChassisNumber] = useState("");
    const [plateNumber, setPlateNumber] = useState("");
    const [operationNumber, setOperationNumber] = useState("");
    const [isActive, setIsActive] = useState(false);
    const [company_id, setCompanyID] = useState("");
    const [device_id, setDeviceID] = useState("");
    const [fuelType, setFuelType] = useState("");
    const [brand, setBrand] = useState("");
    const [year, setYear] = useState("");

    const updateVehicle = async () => {
        const updatedVehicle = {
            isActive: form.getFieldValue("isActive"),
            company_id: form.getFieldValue("company_id"),
            device_id: form.getFieldValue("device_id"),
            chassisNumber: form.getFieldValue("chassisNumber"),
            plateNumber: form.getFieldValue("plateNumber"),
            operationNumber: form.getFieldValue("operationNumber"),
            fuelType: form.getFieldValue("fuelType"),
            brand: form.getFieldValue("brand"),
            year: form.getFieldValue("year"),
        }
        if (updatedVehicle) {
            try {
                const res = await updateHandle({token: user?.token, data: updatedVehicle, id}).unwrap();
                if (res) {
                    message.success('Güncelleme işlemi başarılı');
                    refetchVehicleById();
                    refetchAllVehicles();
                    navigate('/settings/vehicles')
                }
            } catch (e) {
                message.error(e?.data?.messageTR || 'Bir sorun ile karşılaşıldı.');
            }
        }
    }

    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
        message.error(errorInfo, 3)
    };

    const {Option} = Select;

    return (
        <>
            <Breadcrumb>
                <Breadcrumb.Item>
                    <Link to="/">Ana Ekran</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item>
                    <Link to="/settings/vehicles">Araç Listesi</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item>Araç Düzenle</Breadcrumb.Item>
            </Breadcrumb>
            <Card
                style={{marginTop: 15}}
            >
                {isLoading && (
                    <div>yükleniyor</div>
                )}
                <Form
                    name="update-vehicle"
                    form={form}
                    onFinish={updateVehicle}
                    onFinishFailed={onFinishFailed}
                    autoComplete="off"
                >
                    <Form.Item label="Kapı No / Plaka  No" style={{marginBottom: 0}}>
                        <Form.Item
                            style={{display: 'inline-block', width: 'calc(50% - 8px)'}}
                            name="operationNumber"
                            rules={[
                                {
                                    required: true,
                                    message: 'lütfen operation numarasını giriniz !',
                                }
                            ]}
                            onChange={e => setOperationNumber(e.target.value)}
                            value={operationNumber}
                        >
                            <Input placeholder="Operation No"/>
                        </Form.Item>
                        <Form.Item
                            style={{display: 'inline-block', width: 'calc(50% - 8px)', margin: '0 8px'}}
                            name="plateNumber"
                            rules={[
                                {
                                    required: true,
                                    message: 'lütfen plaka giriniz !',
                                },
                            ]}
                            onChange={e => setPlateNumber(e.target.value)}
                            value={plateNumber}
                        >
                            <Input/>
                        </Form.Item>
                    </Form.Item>
                    <Form.Item label="Şase No / Araç Durumu" style={{marginBottom: 0}}>
                        <Form.Item
                            style={{display: 'inline-block', width: 'calc(50% - 8px)'}}
                            name="chassisNumber"
                            rules={[
                                {
                                    required: true,
                                    message: 'lütfen şase numarasını giriniz !',
                                },
                            ]}
                            onChange={e => setChassisNumber(e.target.value)}
                            value={chassisNumber}
                        >
                            <Input/>
                        </Form.Item>
                        <Form.Item
                            style={{display: 'inline-block', width: 'calc(50% - 8px)', margin: '0 8px'}}
                            name="isActive"
                            rules={[
                                {
                                    required: true,
                                    message: 'lütfen durum giriniz !',
                                },
                            ]}
                            value={isActive}
                        >
                            <Select
                                onChange={(e) => setIsActive({...isActive})}
                                allowClear
                            >
                                <Option value={true}>Aktif</Option>
                                <Option value={false}>Pasif</Option>
                            </Select>
                        </Form.Item>
                    </Form.Item>
                    <Form.Item label="Yakıt Türü / Cihaz ID" style={{marginBottom: 0}}>
                        <Form.Item
                            style={{display: 'inline-block', width: 'calc(50% - 8px)'}}
                            name="fuelType"
                            rules={[
                                {
                                    required: true,
                                    message: 'lütfen şase numarasını giriniz !',
                                },
                            ]}
                            onChange={e => setFuelType(e.target.value)}
                            value={fuelType}
                        >
                            <Select
                                onChange={(e) => setFuelType({...fuelType})}
                                placeholder="Yakıt türünü seçiniz.."
                                allowClear
                            >
                                <Option value="diesel">Diesel</Option>
                                <Option value="cng">CNG</Option>
                            </Select>
                        </Form.Item>
                        <Form.Item
                            style={{display: 'inline-block', width: 'calc(50% - 8px)', margin: '0 8px'}}
                            name="device_id"
                            rules={[
                                {
                                    required: true,
                                    message: 'lütfen cihaz id seçiniz !',
                                },
                            ]}
                            value={device_id}
                        >
                            <SearchDevice onChange={e => setDeviceID(e.target.value)}/>
                        </Form.Item>
                    </Form.Item>
                    <Form.Item label="Marka / Yıl" style={{marginBottom: 0}}>
                        <Form.Item
                            style={{display: 'inline-block', width: 'calc(50% - 8px)'}}
                            name="brand"
                            rules={[
                                {
                                    required: true,
                                    message: 'lütfen şase numarasını giriniz !',
                                },
                            ]}
                            onChange={e => setBrand(e.target.value)}
                            value={brand}
                        >
                            <Select
                                onChange={(e) => setBrand({...brand})}
                                placeholder="Marka seçiniz.."
                                allowClear
                            >
                                <Option value="mercedes">Mercedes</Option>
                                <Option value="otokar">Otokar</Option>
                            </Select>
                        </Form.Item>
                        <Form.Item
                            style={{display: 'inline-block', width: 'calc(50% - 8px)', margin: '0 8px'}}
                            name="year"
                            rules={[
                                {
                                    required: true,
                                    message: 'lütfen yıl giriniz !',
                                },
                            ]}
                            value={year}
                        >
                            <Select
                                onChange={(e) => setYear({...year})}
                                placeholder="Yıl seçiniz.."
                                allowClear
                            >
                                <Option value="2024">2024</Option>
                                <Option value="2023">2023</Option>
                                <Option value="2022">2022</Option>
                                <Option value="2021">2021</Option>
                                <Option value="2020">2020</Option>
                                <Option value="2019">2019</Option>
                                <Option value="2018">2018</Option>
                                <Option value="2017">2017</Option>
                                <Option value="2016">2016</Option>
                                <Option value="2015">2015</Option>
                                <Option value="2014">2014</Option>
                                <Option value="2013">2013</Option>
                                <Option value="2012">2012</Option>
                                <Option value="2011">2011</Option>
                                <Option value="2010">2010</Option>
                            </Select>
                        </Form.Item>
                    </Form.Item>
                    <Form.Item
                        label="Şirket Seçiniz"
                        name="company_id"
                        rules={[
                            {
                                required: true,
                                message: 'lütfen şirket seçiniz!',
                            },
                        ]}
                        onChange={e => setCompanyID(e.target.value)}
                        value={company_id}
                    >
                        <SearchCompany onChange={e => setCompanyID(e.target.value)}/>
                    </Form.Item>
                    <Form.Item>
                        <Button style={{marginBottom: 5}} loading={updateLoading} type="primary" htmlType="submit"
                                icon={<SaveOutlined/>}>
                            Güncelle
                        </Button>
                        <Button href="/settings/vehicles" style={{marginLeft: 3}} type="primary" danger
                                icon={<CloseOutlined/>}>
                            Vazgeç
                        </Button>
                        <DeleteVehicle id={data?.id}/>
                    </Form.Item>
                </Form>
            </Card>
        </>
    );
}

export default UpdateVehicle;
